// extracted by mini-css-extract-plugin
export default {"count":"desktop_type_item_count-module__count--AG-MK","plus":"desktop_type_item_count-module__plus--2Iobp"};